import Spinner from 'shared-resources/components/src/Spinner'

export default Spinner;